import React, { lazy, Suspense } from "react";
import { createRoot } from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.css";
import "./assets/GlobalStyle.css";

import ReactDOM from "react-dom";
import { SpinnerComponent } from "./components/Spinner";
import AuthProvider from "./context/AuthContext";
import "./index.css";
import { InventoryProvider } from "./context/InventoryContext";
const LazyApp = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <InventoryProvider>
        <Suspense fallback={<SpinnerComponent />}>
          <LazyApp />
        </Suspense>
      </InventoryProvider>
    </AuthProvider>
  </React.StrictMode >,
  document.getElementById("root")
);
